import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environment/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { HttpHelperService } from './helper.service';
import { ApiResponse } from '../models/apiResponse';
import { Course } from '../models/courseModels'

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  private apiUrl = `${environment.apiBaseUrl}/courses`;

  constructor(
    private http: HttpClient,
    private httpHelper: HttpHelperService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  /**
   * Retrieves a list of courses for a specific bot and optional type from the Deno backend.
   * @param bot The bot identifier (e.g., 'lwazi', 'lesedi', 'kitso').
   * @param type Optional course type (defaults to 'path' if not provided).
   * @returns Observable of Course array.
   */
  getCoursesByBot(
    bot: string,
    type: string = 'path'
  ): Observable<Course[]> {
    const url = `${this.apiUrl}/${bot}/${type}`;
    return this.http.get<ApiResponse<Course[]>>(url, { headers: this.httpHelper.getHeaders() }).pipe(
      map(response => {
        if (!response.success || !response.data) {
          throw new Error(response.error || 'Invalid response from server');
        }
        return response.data;
      }),
      catchError(error => this.handleError(error))
    );
  }

  /**
   * Handles HTTP errors for both browser and server-side contexts.
   * @param error The error to handle.
   * @returns Observable that throws an error with a user-facing message.
   */
  private handleError(error: HttpErrorResponse | any): Observable<never> {
    let errorMessage = 'An unknown error occurred!';
    if (isPlatformBrowser(this.platformId)) {
      if (error.error instanceof ErrorEvent) {
        errorMessage = `Client/Network Error: ${error.error.message}`;
        console.error('Client/Network Error:', error.error.message);
      } else if (error instanceof HttpErrorResponse) {
        const backendError = error.error?.error || error.message;
        errorMessage = `Error ${error.status}: ${backendError}`;
        console.error(`Backend error: ${error.status}`, error.error);
      } else {
        errorMessage = `Browser error: ${error.message || error}`;
        console.error('Unknown Browser Error:', error);
      }
    } else {
      if (error instanceof HttpErrorResponse) {
        const backendError = error.error?.error || error.message;
        errorMessage = `SSR Error ${error.status}: ${backendError}`;
        console.error(`Backend error (Server): ${error.status}`, error.message);
      } else {
        errorMessage = `Server-side error: ${error.message || error}`;
        console.error('Server-side Error:', error);
      }
    }
    return throwError(() => new Error(errorMessage));
  }
}